import { createClient } from '@base44/sdk';
import { appParams } from '@/lib/app-params';

const { appId, serverUrl, token, functionsVersion } = appParams;

// The SDK's analytics module calls auth.me() SYNCHRONOUSLY while the client is
// being constructed, so patching base44.auth.me afterwards is too late — the
// unauthenticated request already fired and logged a 401 console error. For
// anonymous visitors we block that specific request at the XHR level, installed
// BEFORE the client is created. (Logged-in sessions reload the page with a
// token, so the blocker is never installed for them.)
const __anonymous = !token && (typeof window === "undefined" || !window.localStorage.getItem("base44_access_token"));
if (typeof window !== "undefined" && __anonymous) {
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isUserMe = typeof url === "string" && url.indexOf("/entities/User/me") !== -1;
    return origOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__isUserMe) {
      const xhr = this;
      setTimeout(() => {
        try { xhr.dispatchEvent(new ProgressEvent("error")); } catch (_) { /* ignore */ }
      }, 0);
      return;
    }
    return origSend.apply(this, args);
  };
}

//Create a client with authentication required
export const base44 = createClient({
  appId,
  serverUrl,
  token,
  functionsVersion,
  requiresAuth: false
});

// Anonymous visitors have no token, but the SDK's analytics module still calls
// auth.me() once per session to look up a user id — producing a 401 network
// error in the console (flagged by Lighthouse). Short-circuit me() locally when
// no token exists anywhere, so no unauthenticated request is ever sent.
try {
  const hasToken = !!(token || (typeof window !== "undefined" && window.localStorage.getItem("base44_access_token")));
  if (!hasToken && base44 && base44.auth && typeof base44.auth.me === "function") {
    base44.auth.me = () => Promise.reject(new Error("Not authenticated (anonymous visitor)"));
  }
} catch (_) { /* never block client creation */ }
